<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw TitlePage-rw exclude-print-rw" epub:type="frontmatter titlepage" id="BookTitlePage1">
<h1 class="title"><a id="page-v"></a>A HELL OF A WOMAN</h1>
<h1 class="author">JIM<br/>THOMPSON</h1>
<p class="logo"><img alt="" src="images/mulholland_logo_online.jpg"/></p>
<p class="firstpara">Little, Brown and Company</p>
<p class="firstpara1">New York   Boston   London</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?1de7ee6c